import { Component } from '@angular/core';
// superclass
import { Module } from '../module.component';
// services
import { Status } from '../../service/status.service';
import { LotCharactsService } from './lot-characts.service';
// models
import { LotCharactsRequest } from '../../model/lot/lot_characts_request.model';
import { LotCharactsResponse } from '../../model/lot/lot_characts_response.model';

@Component({
  selector: 'app-modal-lot-characts',
  templateUrl: './modal-lot-characts.component.html',
  providers:
  [
    LotCharactsService
  ]
})
export class ModalLotCharactsComponent extends Module {

  public visible = false;
  public visibleAnimate = false;
  lot_number = '';

  lot_characts_request = new LotCharactsRequest();
  lot_characts_response = new LotCharactsResponse();

  constructor(private status:                        Status,
              private lotCharactsService:            LotCharactsService) {
    super();
    this.setBindExposer(this.status.getExposer());
    this.getExposer().getModelsManager().lot_characts_request;
  }

  // return true if service is stil searching
  isServiceSearching() {
    return this.lotCharactsService.isSearching();
  }

  // returns the status of the server query
  isResultEmpty() {
    return this.getModelsManager().lot_characts_response.contained_bean.length === 0 ? true : false;
  }

  show() {
    this.visible = true;
    setTimeout(() => {
      this.visibleAnimate = true;
    }, 100);
  }

  hide() {
    this.visibleAnimate = false;
    setTimeout(() => {
      this.visible = false;
    }, 100);
  }

  setCharacts(lotNumber, language) {
    this.lot_number = lotNumber;
    this.getModelsManager().lot_characts_request.lot_number = lotNumber;
    this.getModelsManager().lot_characts_request.language = language;
    this.doSearch();
  }

  getLotCharactsResponse() {
    return this.getModelsManager().lot_characts_response.contained_bean;
  }

  doSearch() {
    this.lotCharactsService.searchCharacts();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/MODAL-lot-characts/modal-lot-characts.component.ts